import React, { FunctionComponent } from 'react';
import { SelectInput, SelectInputProps, useRecordContext } from 'react-admin';

interface SelectChoiceInputProps extends Omit<SelectInputProps, 'choices'> {
  status_list?: Array<{ id: string | number; name: string }>;
}

const SelectChoiceInput: FunctionComponent<SelectChoiceInputProps> = (
  props
) => {
  const { source, status_list = [], ...restProps } = props;
  const choicesWithDisabled = status_list.map((choice) => {
    const isProformaDisabled = choice.id === 'proforma';
    const isCancelledDisabled = choice.id === 'cancelled';
    const isDraftDisabled = choice.id === 'draft';

    return {
      ...choice,
      disabled: isProformaDisabled || isCancelledDisabled || isDraftDisabled,
    };
  });

  return (
    <SelectInput
      source={source}
      choices={choicesWithDisabled}
      disableValue="disabled"
      {...restProps}
    />
  );
};

export default SelectChoiceInput;
